import { request } from '@/api/http';

export interface PendingUser {
  id: string;
  email: string | null;
  name: string | null;
  status: string;
  createdAt?: string | null;
}

export type ApproveApplicantIn = {
  organizationId?: string;
  organizationName?: string;
  membershipRole: string;
  planSlug?: string;
};

export const userApprovalService = {
  listPending: () => request<PendingUser[]>('/users/pending'),
  approve: (userId: string, body: ApproveApplicantIn) =>
    request<void>(`/users/${userId}/approve`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  reject: (
    userId: string,
    body: { internalNote?: string; customerMessage?: string; includeCustomerMessage?: boolean; reason?: string },
  ) =>
    request<void>(`/users/${userId}/reject`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};
